import { useEffect, useState } from "react";
import { ExternalLink, LoaderCircle, MessageSquarePlus, Send, Star } from "lucide-react";
import { useT } from "../../i18n/LanguageContext";

const GOOGLE_REVIEW_URL = "https://g.page/r/CUxDIl2L8-66EBM/review";
const AIRBNB_URL = "https://www.airbnb.com/rooms/1680628178999969770";

const AIRBNB_REVIEWS = [
  {
    name: "Cindy",
    rating: 5,
    relativeTime: "Há 2 semanas",
    text: "Rute y Carlos son excelentes anfitriones, siempre dispuestos a colaborar, recomendar los mejores lugares o resolver cualquier inquietud. …",
  },
  {
    name: "Eduardo",
    rating: 5,
    relativeTime: "Há 3 dias",
    text: "Rute es una persona muy atenta y amable. La casa estaba impecable",
  },
  {
    name: "Simon",
    rating: 5,
    relativeTime: "Há 3 semanas",
    text: "Eine sehr sehr tolle Unterkunft super Gastgeber und noch ein Einkaufsladen in der Nähe",
  },
];

const DIRECT_REVIEWS = [
  {
    name: "Cláudia Pinto",
    rating: 5,
    date: "30 de julho de 2026",
    text: "Fiquei hospedada na casa da Rute e do Carlos e a experiência foi maravilhosa! Os anfitriões são extremamente simpáticos e atenciosos, sempre prontos para ajudar e oferecer ótimas dicas sobre a região. A casa é linda e estava impecavelmente limpa, o que fez toda a diferença na nossa estadia. Recomendo a todos que desejam uma hospedagem aconchegante e acolhedora. Com certeza voltaremos",
  },
];

const copy = {
  pt: {
    airbnbTitle: "Avaliações Airbnb",
    airbnbSubtitle: "3 avaliações verificadas · classificação 5,0",
    airbnbButton: "Ver todas no Airbnb",
    airbnbSource: "Avaliação verificada no Airbnb",
    googleTitle: "Avaliações Google",
    googleEmpty: "Ainda não existem avaliações no Google. Seja a primeira pessoa a deixar uma opinião.",
    googleError: "Não foi possível carregar as avaliações Google neste momento.",
    googleButton: "Deixar uma avaliação no Google",
    googleCount: "avaliações",
    directPublishedTitle: "Avaliações de reservas diretas",
    directPublishedSubtitle: "Opiniões confirmadas pela MexiHome5",
    directPublishedSource: "Reserva direta confirmada pela MexiHome5",
    directTitle: "Avaliação de reserva direta",
    directBody: "Este formulário destina-se a hóspedes que reservaram diretamente com a MexiHome5. A opinião é enviada para validação antes de ser publicada.",
    name: "Nome",
    email: "Email",
    rating: "Avaliação",
    comment: "Comentário",
    placeholder: "Escreva aqui a sua experiência na MexiHome5…",
    submit: "Enviar opinião",
    sending: "A enviar…",
    success: "Muito obrigado! A sua opinião foi enviada com sucesso.",
    error: "Não foi possível enviar a opinião. Tente novamente.",
    source: "Publicado no Google",
  },
  en: {
    airbnbTitle: "Airbnb reviews",
    airbnbSubtitle: "3 verified reviews · 5.0 rating",
    airbnbButton: "View all on Airbnb",
    airbnbSource: "Verified Airbnb review",
    googleTitle: "Google reviews",
    googleEmpty: "There are no Google reviews yet. Be the first to leave one.",
    googleError: "Google reviews could not be loaded right now.",
    googleButton: "Leave a Google review",
    googleCount: "reviews",
    directPublishedTitle: "Direct booking reviews",
    directPublishedSubtitle: "Reviews confirmed by MexiHome5",
    directPublishedSource: "Direct booking confirmed by MexiHome5",
    directTitle: "Direct booking review",
    directBody: "This form is for guests who booked directly with MexiHome5. Reviews are checked before publication.",
    name: "Name",
    email: "Email",
    rating: "Rating",
    comment: "Comment",
    placeholder: "Write about your experience at MexiHome5…",
    submit: "Send review",
    sending: "Sending…",
    success: "Thank you! Your review was sent successfully.",
    error: "The review could not be sent. Please try again.",
    source: "Published on Google",
  },
  fr: {
    airbnbTitle: "Avis Airbnb",
    airbnbSubtitle: "3 avis vérifiés · note 5,0",
    airbnbButton: "Voir tous les avis sur Airbnb",
    airbnbSource: "Avis vérifié sur Airbnb",
    googleTitle: "Avis Google",
    googleEmpty: "Il n’y a pas encore d’avis Google. Soyez la première personne à en laisser un.",
    googleError: "Impossible de charger les avis Google pour le moment.",
    googleButton: "Laisser un avis Google",
    googleCount: "avis",
    directPublishedTitle: "Avis de réservations directes",
    directPublishedSubtitle: "Avis confirmés par MexiHome5",
    directPublishedSource: "Réservation directe confirmée par MexiHome5",
    directTitle: "Avis d’une réservation directe",
    directBody: "Ce formulaire est destiné aux clients ayant réservé directement auprès de MexiHome5. Les avis sont vérifiés avant publication.",
    name: "Nom",
    email: "E-mail",
    rating: "Évaluation",
    comment: "Commentaire",
    placeholder: "Décrivez votre expérience à MexiHome5…",
    submit: "Envoyer l’avis",
    sending: "Envoi…",
    success: "Merci ! Votre avis a été envoyé avec succès.",
    error: "Impossible d’envoyer l’avis. Réessayez.",
    source: "Publié sur Google",
  },
  es: {
    airbnbTitle: "Opiniones de Airbnb",
    airbnbSubtitle: "3 opiniones verificadas · valoración 5,0",
    airbnbButton: "Ver todas en Airbnb",
    airbnbSource: "Opinión verificada en Airbnb",
    googleTitle: "Opiniones de Google",
    googleEmpty: "Todavía no hay opiniones en Google. Sea la primera persona en dejar una.",
    googleError: "No se pudieron cargar las opiniones de Google.",
    googleButton: "Dejar una opinión en Google",
    googleCount: "opiniones",
    directPublishedTitle: "Opiniones de reservas directas",
    directPublishedSubtitle: "Opiniones confirmadas por MexiHome5",
    directPublishedSource: "Reserva directa confirmada por MexiHome5",
    directTitle: "Opinión de reserva directa",
    directBody: "Este formulario está destinado a huéspedes que reservaron directamente con MexiHome5. Las opiniones se revisan antes de publicarse.",
    name: "Nombre",
    email: "Correo electrónico",
    rating: "Valoración",
    comment: "Comentario",
    placeholder: "Escriba su experiencia en MexiHome5…",
    submit: "Enviar opinión",
    sending: "Enviando…",
    success: "¡Gracias! Su opinión se ha enviado correctamente.",
    error: "No se pudo enviar la opinión. Inténtelo de nuevo.",
    source: "Publicado en Google",
  },
  de: {
    airbnbTitle: "Airbnb-Bewertungen",
    airbnbSubtitle: "3 verifizierte Bewertungen · 5,0 Punkte",
    airbnbButton: "Alle auf Airbnb ansehen",
    airbnbSource: "Verifizierte Airbnb-Bewertung",
    googleTitle: "Google-Bewertungen",
    googleEmpty: "Es gibt noch keine Google-Bewertungen. Seien Sie die erste Person, die eine Bewertung abgibt.",
    googleError: "Google-Bewertungen konnten derzeit nicht geladen werden.",
    googleButton: "Google-Bewertung abgeben",
    googleCount: "Bewertungen",
    directPublishedTitle: "Bewertungen von Direktbuchungen",
    directPublishedSubtitle: "Von MexiHome5 bestätigte Bewertungen",
    directPublishedSource: "Direktbuchung von MexiHome5 bestätigt",
    directTitle: "Bewertung einer Direktbuchung",
    directBody: "Dieses Formular ist für Gäste bestimmt, die direkt bei MexiHome5 gebucht haben. Bewertungen werden vor der Veröffentlichung geprüft.",
    name: "Name",
    email: "E-Mail",
    rating: "Bewertung",
    comment: "Kommentar",
    placeholder: "Beschreiben Sie Ihre Erfahrung bei MexiHome5…",
    submit: "Bewertung senden",
    sending: "Wird gesendet…",
    success: "Vielen Dank! Ihre Bewertung wurde erfolgreich gesendet.",
    error: "Die Bewertung konnte nicht gesendet werden. Bitte versuchen Sie es erneut.",
    source: "Auf Google veröffentlicht",
  },
};

function Stars({ value, size = 18 }) {
  return (
    <div className="flex items-center gap-1 text-[#e3b25b]" aria-label={`${value}/5`}>
      {[1, 2, 3, 4, 5].map((star) => (
        <Star
          key={star}
          size={size}
          className={star <= Math.round(value) ? "fill-[#e3b25b] text-[#e3b25b]" : "text-[#0e1a3f]/20"}
        />
      ))}
    </div>
  );
}

export default function Reviews() {
  const { t, lang } = useT();
  const c = copy[lang] || copy.pt;
  const [google, setGoogle] = useState(null);
  const [googleLoading, setGoogleLoading] = useState(true);
  const [googleError, setGoogleError] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  const [sending, setSending] = useState(false);
  const [status, setStatus] = useState("");

  useEffect(() => {
    let cancelled = false;

    async function loadGoogleReviews() {
      setGoogleLoading(true);
      setGoogleError(false);
      try {
        const response = await fetch(`/api/google-reviews?lang=${encodeURIComponent(lang)}`);
        const data = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(data.detail || "Google reviews unavailable");
        if (!cancelled) setGoogle(data);
      } catch {
        if (!cancelled) setGoogleError(true);
      } finally {
        if (!cancelled) setGoogleLoading(false);
      }
    }

    loadGoogleReviews();
    return () => {
      cancelled = true;
    };
  }, [lang]);

  async function submitReview(event) {
    event.preventDefault();
    setStatus("");

    if (!name.trim() || !email.trim() || rating < 1 || comment.trim().length < 10) {
      setStatus(c.error);
      return;
    }

    setSending(true);
    try {
      const response = await fetch("/api/reviews", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name, email, rating, comment }),
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(data.detail || c.error);

      setName("");
      setEmail("");
      setRating(0);
      setComment("");
      setStatus(c.success);
    } catch (error) {
      setStatus(error.message || c.error);
    } finally {
      setSending(false);
    }
  }

  return (
    <section id="avaliacoes" className="py-20 md:py-28" data-testid="reviews-section">
      <div className="max-w-6xl mx-auto px-6 text-center">
        <div className="reveal">
          <p className="section-label justify-center">{t.reviews.eyebrow}</p>
          <h2 className="font-display text-4xl md:text-5xl mt-4 text-[#0e1a3f] leading-tight">
            {t.reviews.title1} <em className="text-[#1e3a8a]">{t.reviews.title2}</em>
          </h2>
        </div>

        <div className="reveal mt-12 rounded-3xl bg-white p-6 sm:p-10 text-left ring-1 ring-[#0e1a3f]/10">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-5">
            <div>
              <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#ff385c]">Airbnb</p>
              <h3 className="font-display text-3xl text-[#0e1a3f] mt-2">{c.airbnbTitle}</h3>
              <div className="flex flex-wrap items-center gap-3 mt-3">
                <strong className="text-2xl text-[#0e1a3f]">5,0</strong>
                <Stars value={5} size={20} />
                <span className="text-sm text-[#0e1a3f]/65">{c.airbnbSubtitle}</span>
              </div>
            </div>
            <a
              href={AIRBNB_URL}
              target="_blank"
              rel="noreferrer"
              className="btn-primario inline-flex self-start md:self-center"
              data-testid="airbnb-reviews-button"
            >
              {c.airbnbButton} <ExternalLink size={15} />
            </a>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 mt-8">
            {AIRBNB_REVIEWS.map((review) => (
              <article key={review.name} className="bg-[#faf6ee] rounded-2xl p-6 ring-1 ring-[#0e1a3f]/10">
                <div className="flex items-center gap-3">
                  <div className="w-11 h-11 rounded-full bg-[#ff385c] text-white flex items-center justify-center font-bold">
                    {review.name.slice(0, 1).toUpperCase()}
                  </div>
                  <div>
                    <h4 className="font-semibold text-[#0e1a3f]">{review.name}</h4>
                    <p className="text-xs text-[#0e1a3f]/55">{review.relativeTime}</p>
                  </div>
                </div>
                <div className="mt-4"><Stars value={review.rating} /></div>
                <p className="mt-4 text-sm leading-relaxed text-[#0e1a3f]/75">{review.text}</p>
                <p className="mt-5 text-xs font-semibold text-[#ff385c]">{c.airbnbSource}</p>
              </article>
            ))}
          </div>
        </div>

        <div className="reveal mt-12 rounded-3xl bg-[#f6ecd9] p-6 sm:p-10 text-left ring-1 ring-[#0e1a3f]/10">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-5">
            <div>
              <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#1e3a8a]">Google</p>
              <h3 className="font-display text-3xl text-[#0e1a3f] mt-2">{c.googleTitle}</h3>
              {google && google.userRatingCount > 0 && (
                <div className="flex flex-wrap items-center gap-3 mt-3">
                  <strong className="text-2xl text-[#0e1a3f]">{google.rating.toFixed(1)}</strong>
                  <Stars value={google.rating} size={20} />
                  <span className="text-sm text-[#0e1a3f]/65">{google.userRatingCount} {c.googleCount}</span>
                </div>
              )}
            </div>
            <a
              href={GOOGLE_REVIEW_URL}
              target="_blank"
              rel="noreferrer"
              className="btn-primario inline-flex self-start md:self-center"
              data-testid="google-review-button"
            >
              {c.googleButton} <ExternalLink size={15} />
            </a>
          </div>

          {googleLoading && (
            <div className="flex items-center justify-center gap-2 py-12 text-[#0e1a3f]/60">
              <LoaderCircle size={22} className="animate-spin" />
            </div>
          )}

          {!googleLoading && googleError && (
            <p className="mt-8 rounded-2xl bg-white/70 p-5 text-[#0e1a3f]/70">{c.googleError}</p>
          )}

          {!googleLoading && !googleError && google?.reviews?.length === 0 && (
            <p className="mt-8 rounded-2xl bg-white/70 p-5 text-[#0e1a3f]/70">{c.googleEmpty}</p>
          )}

          {!googleLoading && !googleError && google?.reviews?.length > 0 && (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 mt-8">
              {google.reviews.map((review, index) => (
                <article key={`${review.author.name}-${review.publishTime}-${index}`} className="bg-white rounded-2xl p-6 ring-1 ring-[#0e1a3f]/10">
                  <div className="flex items-center gap-3">
                    {review.author.photoUrl ? (
                      <img src={review.author.photoUrl} alt="" loading="lazy" className="w-11 h-11 rounded-full object-cover" />
                    ) : (
                      <div className="w-11 h-11 rounded-full bg-[#1e3a8a] text-white flex items-center justify-center font-bold">
                        {review.author.name.slice(0, 1).toUpperCase()}
                      </div>
                    )}
                    <div>
                      <h4 className="font-semibold text-[#0e1a3f]">{review.author.name}</h4>
                      <p className="text-xs text-[#0e1a3f]/55">{review.relativeTime}</p>
                    </div>
                  </div>
                  <div className="mt-4"><Stars value={review.rating} /></div>
                  {review.text && <p className="mt-4 text-sm leading-relaxed text-[#0e1a3f]/75">{review.text}</p>}
                  <p className="mt-5 text-xs font-semibold text-[#1e3a8a]">{c.source}</p>
                </article>
              ))}
            </div>
          )}
        </div>

        <div className="reveal mt-12 rounded-3xl bg-white p-6 sm:p-10 text-left ring-1 ring-[#0e1a3f]/10">
          <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#c89033]">MexiHome5</p>
          <h3 className="font-display text-3xl text-[#0e1a3f] mt-2">{c.directPublishedTitle}</h3>
          <p className="mt-2 text-sm text-[#0e1a3f]/65">{c.directPublishedSubtitle}</p>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 mt-8">
            {DIRECT_REVIEWS.map((review) => (
              <article key={`${review.name}-${review.date}`} className="bg-[#faf6ee] rounded-2xl p-6 ring-1 ring-[#0e1a3f]/10">
                <div className="flex items-center gap-3">
                  <div className="w-11 h-11 rounded-full bg-[#c89033] text-white flex items-center justify-center font-bold">
                    {review.name.slice(0, 1).toUpperCase()}
                  </div>
                  <div>
                    <h4 className="font-semibold text-[#0e1a3f]">{review.name}</h4>
                    <p className="text-xs text-[#0e1a3f]/55">{review.date}</p>
                  </div>
                </div>
                <div className="mt-4"><Stars value={review.rating} /></div>
                <p className="mt-4 text-sm leading-relaxed text-[#0e1a3f]/75">{review.text}</p>
                <p className="mt-5 text-xs font-semibold text-[#c89033]">{c.directPublishedSource}</p>
              </article>
            ))}
          </div>
        </div>

        <form onSubmit={submitReview} className="reveal mt-12 mx-auto max-w-2xl bg-white rounded-3xl p-6 sm:p-10 ring-1 ring-[#0e1a3f]/10 relative text-left">
          <span className="absolute -top-5 left-1/2 -translate-x-1/2 font-display text-7xl text-[#1e3a8a]/15 leading-none">“</span>

          <div className="w-16 h-16 mx-auto rounded-2xl bg-[#f6ecd9] flex items-center justify-center text-[#c89033]">
            <MessageSquarePlus size={28} />
          </div>

          <h3 className="font-display text-2xl md:text-3xl text-[#0e1a3f] mt-5 text-center">{c.directTitle}</h3>
          <p className="mt-3 text-[#0e1a3f]/70 leading-relaxed text-center">{c.directBody}</p>

          <div className="grid sm:grid-cols-2 gap-4 mt-7">
            <label className="text-sm font-semibold text-[#0e1a3f]">
              {c.name}
              <input value={name} onChange={(e) => setName(e.target.value)} maxLength={120} required className="mt-2 w-full rounded-xl border border-[#0e1a3f]/20 px-4 py-3 font-normal outline-none focus:border-[#c89033]" />
            </label>
            <label className="text-sm font-semibold text-[#0e1a3f]">
              {c.email}
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-2 w-full rounded-xl border border-[#0e1a3f]/20 px-4 py-3 font-normal outline-none focus:border-[#c89033]" />
            </label>
          </div>

          <fieldset className="mt-5">
            <legend className="text-sm font-semibold text-[#0e1a3f]">{c.rating}</legend>
            <div className="flex gap-2 mt-2" aria-label={c.rating}>
              {[1, 2, 3, 4, 5].map((value) => (
                <button key={value} type="button" onClick={() => setRating(value)} className="p-1" aria-label={`${value}/5`}>
                  <Star size={30} className={value <= rating ? "fill-[#e3b25b] text-[#e3b25b]" : "text-[#0e1a3f]/25"} />
                </button>
              ))}
            </div>
          </fieldset>

          <label className="block mt-5 text-sm font-semibold text-[#0e1a3f]">
            {c.comment}
            <textarea value={comment} onChange={(e) => setComment(e.target.value)} minLength={10} maxLength={2000} required rows={5} placeholder={c.placeholder} className="mt-2 w-full rounded-xl border border-[#0e1a3f]/20 px-4 py-3 font-normal outline-none focus:border-[#c89033] resize-y" />
          </label>

          {status && <p className="mt-4 text-sm text-center text-[#0e1a3f]" role="status">{status}</p>}

          <button type="submit" disabled={sending} className="btn-primario mt-6 mx-auto flex disabled:opacity-60" data-testid="reviews-submit">
            <Send size={15} /> {sending ? c.sending : c.submit}
          </button>
        </form>
      </div>
    </section>
  );
}
